import { createSelector } from 'reselect'
import createStatusSelector from '../../selectors/createStatusSelector'

const getCardId = (state, props) => props.cardContext.id

export const getStatusChangeDate = (state, props) => {
  return state['view-board'].cards[props.cardContext.id].statusChangeDate
}

export const getStatusChangedBy = (state, props) => {
  return state['view-board'].cards[props.cardContext.id].statusChangedBy
}

export default () => {
  const statusSelector = createStatusSelector(getCardId)

  return createSelector(
    [
      statusSelector,
      getStatusChangeDate,
      getStatusChangedBy
    ],
    (
      status,
      statusChangeDate,
      statusChangedBy
    ) => ({
      status,
      changeDate: statusChangeDate,
      changedBy: statusChangedBy,
    })
  )
}
